/**
 * 由当前路由推导应该点亮的左侧菜单项（返回菜单项的 tab id）。
 *
 * 真正决定高亮的是 admin：app-bridge 只把 `{ label, url, rel }` 同步过去，
 * 由 admin 拿当前路径去匹配菜单项的 url（子路径能点亮父级），
 * 子元素上的 `active` 属性目前不会被同步（读它的 selectedMenuItemId() 是死代码）。
 *
 * 所以「不在菜单里的页面」要点亮某一项，靠的是把它挂到那一项的子路径下
 * （例如套餐页在 /billing/plans），而不是在这里做映射 ——
 * 映射只改 DOM、改不了 admin 的判断，还会引入高亮跳动。
 */

const isSelfOrDescendant = (pathname: string, base: string) =>
  pathname === base || pathname.startsWith(`${base}/`)

/** 去掉结尾斜杠，避免 "/orders/" 匹配不上 "/orders" */
const normalizePathname = (pathname: string) => pathname.replace(/\/+$/, "") || "/"

export const resolveActiveTabId = (pathname: string, tabIds: string[]): string | undefined => {
  // Dashboard 不点亮任何菜单项：它不在菜单里，入口是 admin 侧边栏的应用名
  if (pathname === "/") {
    return undefined
  }

  const normalized = normalizePathname(pathname)

  // 前缀匹配 + 取最长命中：子路由点亮父级菜单项；命中多项时选更具体的那个
  return tabIds
    .filter(id => id !== "/" && isSelfOrDescendant(normalized, id))
    .sort((a, b) => b.length - a.length)[0]
}

export default resolveActiveTabId
